// pages/LegalPages/legal.elements.js
import styled from "@emotion/styled";
import { theme } from "@/theme/theme";

export const LegalPage = styled.div`
    width: 100%;
    max-width: 100%;
    min-width: 0;
    padding: 0;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding: 0 10px;
        box-sizing: border-box;
    }
`;

export const LegalContainer = styled.div`
    width: 100%;
    max-width: 980px;
    margin: 0 auto;
    padding: 24px 0;
    color: ${({ theme }) => theme.colors.text.primary};

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding: 16px 0;
    }
`;

export const LegalCard = styled.div`
    background: ${({ theme }) => theme.palette.primary.dark2};
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius: 12px;
    padding: 22px 22px;
    box-sizing: border-box;
    min-width: 0;
    max-width: 100%;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding: 16px 14px;
    }
`;

export const LegalTitle = styled.h1`
    margin: 0 0 14px 0;
    font-size: ${({ theme }) => theme.fontSizes.h2};
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    color: ${({ theme }) => theme.colors.text.primary};

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        margin-bottom: 12px;
    }
`;

export const LegalSectionTitle = styled.h2`
    margin: 22px 0 10px 0;
    font-size: ${({ theme }) => theme.fontSizes.h3};
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    color: ${({ theme }) => theme.colors.text.primary};

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        margin: 18px 0 10px 0;
    }
`;

export const LegalSubtitle = styled.h3`
    margin: 18px 0 10px 0;
    font-size: ${({ theme }) => theme.fontSizes.large};
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    color: ${({ theme }) => theme.colors.text.primary};
`;

export const LegalText = styled.p`
    margin: 0 0 12px 0;
    line-height: 1.6;
    color: ${({ theme }) => theme.colors.text.secondary || theme.colors.text.primary};
    white-space: pre-wrap;
    overflow-wrap: anywhere;
`;

export const LegalList = styled.ul`
    margin: 0 0 12px 18px;
    padding: 0;
    line-height: 1.6;
    color: ${({ theme }) => theme.colors.text.secondary || theme.colors.text.primary};

    li {
        margin: 6px 0;
        overflow-wrap: anywhere;
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        margin-left: 16px;
    }
`;

export const LegalLink = styled.a`
    color: ${({ theme }) => theme.palette.secondary.main};
    text-decoration: underline;
    cursor: pointer;

    &:hover {
        opacity: 0.9;
    }

    &:visited {
        color: ${({ theme }) => theme.palette.secondary.main};
    }
`;

// (optional) use for mailto specifically, if you want semantic naming
export const LegalEmailLink = styled.a`
    color: ${({ theme }) => theme.palette.secondary.main};
    text-decoration: underline;
    cursor: pointer;

    &:hover {
        opacity: 0.9;
    }

    &:visited {
        color: ${({ theme }) => theme.palette.secondary.main};
    }
`;

export const LegalAddress = styled.div`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  background: ${theme.palette.primary.dark2};
  border: 1px solid rgba(128, 149, 183, 0.22);
  border-radius: 12px;
  padding: 14px 16px;
  box-sizing: border-box;
  color: ${({ theme }) => theme.colors.text.primary};
  line-height: 1.55;

  > div {
    white-space: pre-wrap;
    overflow-wrap: anywhere;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 12px 12px;
  }
`;
